export enum ThirdPartyStatus {
  Active = 1,
  Inactive = 2,
}
